import profile from '../../img/black-profile.webp';
import Socials from './Socials';
import { Link } from 'react-router-dom';

const MainContent = () => {
    return (
        <>
            {/* size */}
            <div className="w-10/12 mx-auto flex pt-5 md:pt-16 pb-24 lg:mb-20">

                {/* content */}
                <div className="grid grid-cols-5 grid-rows-2 justify-items-center items-center md:grid-rows-1 w-11/12 mx-auto">

                    {/* text */}
                    <div className="col-span-5 row-span-1 order-2 space-y-2 md:space-y-10 md:col-span-3 md:order-1 dark:text-white">

                        {/* Socials Icon */}
                        <Socials />

                        <div>
                            <h1 className='text-base md:text-4xl font-bold '>Hello, I'm Michael</h1>
                            <h1 className='text-base md:text-4xl font-bold '>Software Developer</h1>
                        </div>
                        <p className='text-xs md:text-xl font-light '>As an aspiring Software developer, I am passionate about utilizing my technical skills and creativity to build innovative and engaging software application experiences.</p>
                        <div className='flex flex-row gap-3'>
                            <Link to="/ContactPage">
                                <button className='text-xs bg-black px-4 py-1 text-white border border-1 border-black  hover:scale-110 duration-200 dark:bg-white dark:border-white dark:text-black md:text-lg md:px-8 md:py-2'>Reach me out</button>
                            </Link>

                            <Link to="/ProjectPage">
                                <button className='text-xs border border-1 border-black px-4 py-1 dark:border-white hover:scale-110 duration-200  md:text-lg md:px-8 md:py-2'>My Projects</button>
                            </Link>
                        </div>
                    </div>

                    {/* img */}
                    <div className="profilepic col-span-5 row-span-1 order-1 justify-self-center md:col-span-2 md:order-2 md:justify-self-end">
                        <div data-aos="fade-left" data-aos-duration="1000" className='profile h-52 md:h-96 bg-black dark:bg-white'>
                            <img src={profile} alt="Profile" className='profile h-52 md:h-96 relative top-5 right-5' />
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default MainContent;